// Conditional logging utility
// Verbose in development, or when the server marks the current user as a
// developer via `<meta name="verbose-logging" content="true">`. Keeps the
// console clean for regular production users.
// Exception: `logger.init` always logs (initialization markers).

const isDevelopment = () => {
  // Check if Rails environment is available (set in layout)
  return window.RAILS_ENV !== 'production'
}

// Cached once per page load — the meta tag is written server-side and doesn't
// change while the page is live.
let _verboseCache
const isVerbose = () => {
  if (_verboseCache !== undefined) return _verboseCache
  if (isDevelopment()) return (_verboseCache = true)
  const meta = typeof document !== 'undefined'
    ? document.querySelector('meta[name="verbose-logging"]')
    : null
  return (_verboseCache = meta?.content === 'true')
}

export const logger = {
  // Development-only (or developer-role in prod) debug logs
  log: (...args) => {
    if (isVerbose()) {
      console.log(...args)
    }
  },

  // Same gate as log — warnings are noise for regular users
  warn: (...args) => {
    if (isVerbose()) {
      console.warn(...args)
    }
  },

  // Always log errors
  error: (...args) => {
    console.error(...args)
  },

  // Special case: initialization messages that should appear in production
  init: (...args) => {
    console.log(...args)
  }
}
